import { render, staticRenderFns } from "./StudentNavbar.vue?vue&type=template&id=0db6b4c6"
import script from "./StudentNavbar.vue?vue&type=script&lang=js"
export * from "./StudentNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports